const PAGE_NAME = 'ROLE_MANAGEMENT';
const ACCOUNT_PREFERENCES = 'showRoleManagement';

export default { PAGE_NAME, ACCOUNT_PREFERENCES };
